export const portfolioBrands = [
  {
    id: 1,
    name: "Storm Bags",
    category: "Safety & Protection",
    description: "U.S.-designed advanced flood prevention system entering the Australasian market. Revolutionary portable barrier technology for residential and commercial flood protection.",
    status: "Market Entry",
    color: "#3B82F6",
    logo: "https://customer-assets.emergentagent.com/job_premium-ventures-1/artifacts/mnv3ukhl_Stormbag%20LOGO%20.png",
    facebookUrl: "https://www.facebook.com/StormBagsNewZealand",
    logoSize: "large"
  },
  {
    id: 2,
    name: "Sweet Treats",
    category: "Food & Beverage",
    description: "Premium confectionery brand expanding into the beverage sector. Bringing innovation to traditional sweets with modern taste profiles and product formats.",
    status: "Category Expansion",
    color: "#EC4899",
    logo: "https://customer-assets-cm19k8pv.emergentagent.net/job_premium-ventures-1/artifacts/mm1ccv8j_Sweet%20Treats%20Main.png",
    facebookUrl: "https://www.facebook.com/Sweettreatskingsman",
    logoSize: "large"
  },
  {
    id: 3,
    name: "The Mighty Hunter",
    category: "Food & Beverage",
    description: "Premium food showcasing an extensive menu covering both European and Mexican cuisines.",
    status: "Growing",
    color: "#10B981",
    logo: "https://customer-assets-cm19k8pv.emergentagent.net/job_premium-ventures-1/artifacts/0n5v8nzp_Mighty%20Hunter.png",
    facebookUrl: "https://www.facebook.com/ThemightyhunterNZ",
    logoSize: "large"
  },
  {
    id: 4,
    name: "Seal Craft Cocktails",
    category: "Premium Beverages",
    description: "Expertly crafted canned cocktails delivering bar-quality experiences. Premium spirits and natural ingredients in convenient, ready-to-drink formats.",
    status: "Scaling",
    color: "#8B5CF6",
    logo: "https://customer-assets-cm19k8pv.emergentagent.net/job_premium-ventures-1/artifacts/lugawd32_SealCraft_Logo_Primary_MetallicTransparent_DarkBG.png",
    facebookUrl: "https://www.facebook.com/sealcraftcocktails"
  },
  {
    id: 5,
    name: "AhiRā Snacks",
    category: "Innovative Foods",
    description: "High-quality dehydrated snacks and drink enhancers. Natural ingredients transformed into convenient, nutrient-dense products for active lifestyles.",
    status: "Launching",
    color: "#F59E0B",
    logo: "https://customer-assets-cm19k8pv.emergentagent.net/job_premium-ventures-1/artifacts/o17yzant_Ahira%20.jpeg",
    facebookComingSoon: true,
    transparentBg: true
  },
  {
    id: 6,
    name: "Nebula Spirits",
    category: "Premium Beverages",
    description: "Premium spirits brand launching November 2026. A category-defining product positioned to disrupt the spirits market.",
    status: "In Development",
    color: "#8B5CF6",
    logo: "https://customer-assets-cm19k8pv.emergentagent.net/job_premium-ventures-1/artifacts/ozggnm94_Nebula%20Logo.jpeg",
    confidential: true,
    facebookComingSoon: true,
    transparentBg: true
  }
];

export const stats = [
  { value: "6", label: "Portfolio Brands" },
  { value: "2", label: "Markets" },
  { value: "5", label: "Categories" },
  { value: "2025", label: "Founded" }
];

export const contactInfo = {
  email: "info@kingsmangroup.co.nz",
  phone: "027 903 9039",
  tagline: "Innovation for Tomorrow"
};

export const contactTypes = [
  {
    type: "Investment Enquiries",
    description: "Partner with us to scale innovation"
  },
  {
    type: "Distribution Partnerships",
    description: "Bring our brands to your market"
  },
  {
    type: "General Enquiries",
    description: "Connect with our team"
  }
];
